import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Segment,
  Image,
  Loader,
  Dimmer,
  Button,
  List,
} from 'semantic-ui-react';
import { history, store } from '../../helpers';
import Strings from '../../common/Strings';
import '../Common.css';
import './Projects.css';
import { projectActions, teamMemberActions } from '../../actions';
import { Error } from '../common/Error';
import { projectActivityActions } from '../../actions/projectActivity';
import { getLoggedTimeFromMillis } from '../../helpers/workLog';
import { withDayChange } from '../index';
import { getSidePanelDateSectionForWorkLog } from '../../helpers/ui';
import config from '../../config';

const moment = require('moment');

class Projects extends React.Component {
  static renderRootEmpty() {
    const step1 = Strings.PROJECTS.formatString(
      Strings.PROJECTS.getStartedStep1,
      <b>1.</b>,
    );
    const step2 = Strings.PROJECTS.formatString(
      Strings.PROJECTS.getStartedStep2,
      <b>2.</b>,
    );
    const step3 = Strings.PROJECTS.formatString(
      Strings.PROJECTS.getStartedStep3,
      <b>3.</b>,
    );
    return (
      <div className="projects-empty-container">
        <Image
          className="projects-empty-image"
          src="/empty/projects_empty.png"
        />
        <p className="projects-empty-title">
          {Strings.PROJECTS.projectsEmptyTitle}
        </p>
        <div className="projects-get-started-container">
          <p className="projects-get-started-title">
            {Strings.PROJECTS.getStartedTitle}
          </p>
          <p className="projects-get-started-body">
            {Strings.PROJECTS.getStartedBody}
          </p>
          <p className="projects-get-started-step">{step1}</p>
          <p className="projects-get-started-step">{step2}</p>
          <p className="projects-get-started-step">{step3}</p>
        </div>
      </div>
    );
  }

  static renderSidePanelEmpty(activeProjects) {
    const hasActiveTeamMember = activeProjects.find(p => {
      const t = p.teamMembers.find(t => t.status === 'active');
      if (t) {
        return true;
      }
    });
    return (
      <div className="activity-empty-container">
        <Image
          className="activity-empty-image"
          src="/empty/activity_empty.png"
        />
        <p className="activity-empty-title">
          {Strings.PROJECTS.activityEmptyTitle}
        </p>
        {!hasActiveTeamMember && (
          <p className="activity-empty-body">
            {Strings.PROJECTS.activityEmptyBody}
          </p>
        )}
      </div>
    );
  }

  onDayChanged() {
    const { dispatch } = this.props;
    dispatch(projectActivityActions.fetchRecentWorkLogs());
  }

  onClickAddProject = () => {
    if (
      this.props.subscription.status !== 'active' &&
      this.countActiveProjects() >= config.MAX_ACTIVE_PROJECTS_FREE
    ) {
      history.push('#premium');
    } else {
      history.push('#newProject');
    }
  };

  countActiveProjects() {
    let count = 0;
    this.props.projects.forEach(p => {
      if (p.status === 'active') count += 1;
    });
    return count;
  }

  onClickProject = project => {
    history.push(`/projects/${project.id}`);
  };

  renderProjectsContent(activeProjects, closedProjects) {
    const { isLoading, isFailed, projects } = this.props;

    if (isLoading) return null;

    if (isFailed) {
      return (
        <Error
          title={Strings.PROJECTS.failedTitle}
          body={Strings.PROJECTS.failedBody}
          buttonText={Strings.COMMON.tryAgain}
          buttonOnClick={() => {
            if (store.getState().uiState.isProjectsFailed) {
              this.props.dispatch(projectActions.fetchProjects());
            }
            if (store.getState().uiState.isTeamMembersFailed) {
              this.props.dispatch(teamMemberActions.fetchTeamMembers());
            }
          }}
        />
      );
    }

    if (projects.length === 0) {
      return Projects.renderRootEmpty();
    }

    let ActiveProjectsSection;
    let ClosedProjectsSection;

    if (activeProjects.length > 0) {
      const ActiveProjects = activeProjects.map(project => (
        <List.Item
          className="project-list-item"
          key={project.id}
          onClick={() => this.onClickProject(project)}
        >
          <div
            className="project-list-item-color"
            style={{ backgroundColor: project.color }}
          />
          <p className="project-list-item-text">{project.name}</p>
          <Image
            className="project-list-item-members-image"
            src="/icon/members.svg"
          />
          <p className="project-list-item-member-count">
            {
              project.teamMembers.filter(t => t.status !== 'disconnected')
                .length
            }
          </p>
        </List.Item>
      ));

      ActiveProjectsSection = (
        <div style={{ marginBottom: '2rem' }}>
          <p className="active-projects-header">
            {Strings.PROJECTS.activeProjectsHeader}
          </p>
          <List>{ActiveProjects}</List>
        </div>
      );
    }

    if (closedProjects.length > 0) {
      const ClosedProjects = closedProjects.map(project => {
        const { closedAt } = project;
        const date = moment(closedAt).format('YYYY/MM/DD');
        const time = moment(closedAt).format('h:mm:ss A');
        const closedAtText = Strings.PROJECTS.formatString(
          Strings.PROJECTS.closedAt,
          date,
          time,
        );
        return (
          <List.Item
            className="project-list-item closed-project-list-item"
            key={project.id}
            onClick={() => this.onClickProject(project)}
          >
            <div
              className="project-list-item-color"
              style={{ border: `2px solid ${project.color}` }}
            />
            <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
              <p className="project-list-item-text project-list-item-text-disabled">
                {project.name}
              </p>
              <p className="project-list-item-text-closed">{closedAtText}</p>
            </div>
          </List.Item>
        );
      });

      ClosedProjectsSection = (
        <div>
          <p className="closed-projects">{Strings.PROJECTS.closedProjects}</p>
          <div className="closed-projects-divider" />
          <p className="active-projects-header">
            {Strings.PROJECTS.closedProjectsHeader}
          </p>
          <List>{ClosedProjects}</List>
        </div>
      );
    }

    return (
      <div>
        {ActiveProjectsSection}
        {ClosedProjectsSection}
      </div>
    );
  }

  renderSidePanelContent(activeProjects) {
    const {
      isLoading,
      isFailed,
      isActivityLoading,
      isActivityFailed,
      recentActivity,
    } = this.props;

    if (isLoading || isActivityLoading) return null;

    if (isFailed || isActivityFailed) {
      return (
        <Error
          title={Strings.PROJECTS.activityFailedTitle}
          body={Strings.PROJECTS.activityFailedBody}
          buttonText={Strings.COMMON.tryAgain}
          buttonOnClick={() => {
            if (store.getState().uiState.isProjectsFailed) {
              this.props.dispatch(projectActions.fetchProjects());
            }
            if (store.getState().uiState.isTeamMembersFailed) {
              this.props.dispatch(teamMemberActions.fetchTeamMembers());
            }
            if (isActivityFailed) {
              this.props.dispatch(projectActivityActions.fetchRecentWorkLogs());
            }
          }}
        />
      );
    }

    if (recentActivity.length === 0) {
      return Projects.renderSidePanelEmpty(activeProjects);
    }

    const teamMembersMap = new Map();
    this.props.teamMembers.forEach(t => teamMembersMap.set(t.email, t));

    const projectsMap = new Map();
    this.props.projects.forEach(p => projectsMap.set(p.id, p));
    const RecentActivity = recentActivity.map((workLog, index, array) => {
      let userName = teamMembersMap.has(workLog.userEmail)
        ? teamMembersMap.get(workLog.userEmail).name
        : workLog.userEmail;
      if (!userName) userName = workLog.userEmail;
      const timestamp = moment(workLog.timestamp).format('h:mm A');
      const loggedTime = getLoggedTimeFromMillis(
        workLog.totalLoggedMillis,
        true,
      );
      const projectName = projectsMap.get(workLog.projectId).name;
      const loggedTimeTo = Strings.PROJECTS.formatString(
        Strings.PROJECTS.loggedTimeTo,
        projectName,
      );
      const hourStyle = `recent-activity-list-item-hours ${
        workLog.totalLoggedMillis > 0
          ? 'recent-activity-list-item-hours-positive'
          : 'recent-activity-list-item-hours-negative'
      }`;

      const DateSection = getSidePanelDateSectionForWorkLog(
        workLog,
        index,
        array,
      );

      return (
        <List.Item className="recent-activity-list-item" key={workLog.id}>
          {DateSection}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <p className="recent-activity-list-item-name">{userName}</p>
            <p className="recent-activity-list-item-time">{timestamp}</p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <p className={hourStyle}>{loggedTime}</p>
            <p className="recent-activity-list-item-to">{loggedTimeTo}</p>
          </div>
        </List.Item>
      );
    });
    return <List>{RecentActivity}</List>;
  }

  render() {
    const { isLoading, isFailed, isActivityLoading, projects } = this.props;
    const activeProjects = projects.filter(
      project => project.status === 'active',
    );
    const closedProjects = projects.filter(
      project => project.status === 'closed',
    );
    return (
      <Segment basic className="projects-root">
        <Segment basic className="projects">
          <Dimmer active={isLoading} inverted>
            <Loader inverted />
          </Dimmer>
          <div className="common-top-panel">
            <h1 id="projects-title" className="common-top-panel-title">
              {Strings.PROJECTS.projects}
            </h1>
            <div style={{ flex: 1 }} />
            <Button
              id="add-project-button"
              className="common-light-button"
              onClick={this.onClickAddProject}
              disabled={isLoading || isFailed}
            >
              {Strings.PROJECTS.addProject}
            </Button>
          </div>
          <div className="projects-content-wrapper">
            <div className="projects-content">
              {this.renderProjectsContent(activeProjects, closedProjects)}
              {!isFailed && (
                <Image className="app-footer-logo" src="/circles-grey.png" />
              )}
            </div>
          </div>
        </Segment>
        <Segment basic className="common-side-panel">
          <Dimmer active={isActivityLoading} inverted>
            <Loader inverted />
          </Dimmer>
          <div className="common-top-panel">
            <h1 id="activity-title" className="common-side-panel-title">
              {Strings.PROJECTS.activity}
            </h1>
          </div>
          <div className="projects-side-panel-content">
            {this.renderSidePanelContent(activeProjects)}
          </div>
        </Segment>
      </Segment>
    );
  }
}

Projects.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isFailed: PropTypes.bool.isRequired,
  isActivityLoading: PropTypes.bool.isRequired,
  isActivityFailed: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }),
  ).isRequired,
  teamMembers: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
  ).isRequired,
  recentActivity: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      userEmail: PropTypes.string.isRequired,
      timestamp: PropTypes.string.isRequired,
      projectId: PropTypes.string.isRequired,
      totalLoggedMillis: PropTypes.number.isRequired,
    }),
  ).isRequired,
  subscription: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  isLoading:
    state.uiState.isProjectsLoading || state.uiState.isTeamMembersLoading,
  isFailed: state.uiState.isProjectsFailed || state.uiState.isTeamMembersFailed,
  isActivityLoading: state.uiState.isProjectsRecentActivityLoading,
  isActivityFailed: state.uiState.isProjectsRecentActivityFailed,
  projects: state.projects,
  teamMembers: state.teamMembers,
  recentActivity: state.projectRecentsWorkLogs,
  subscription: state.premiumSubscription.subscription,
});

export default connect(mapStateToProps)(withDayChange(Projects));



// WEBPACK FOOTER //
// ./src/components/projects/Projects.js